import actionType from '../actions/billing/actionType';

const initialState = {
  feeTableList: [],
  feeIsLoading: false,
  feePageNum: 1,
  feePageSize: 50,
  feeTotal: 0,
  expenseEndDate: null,
  expenseStartDate: null,
  // ascription: null,
  approvalState: null,
  approvalCashFlowId: null,
  expenseCreateStartDate: null,
  expenseCreateEndDate: null,

  checkTableList: [],
  checkIsLoading: false,
  checkPageNum: 1,
  checkPageSize: 50,
  checkTotal: 0,
  allyState: null,
  checkPreviewData: null,
  approveDetailData: null,

  cashFlowIntervalList: [], // 现流周期
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.BILLING_UPDATE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
